<template>
  <section
    class="Eula color-mute mt-3">
   <h3>EULA</h3>
   <p
    class="pt-2">
     By obtaining a license to use this App, you are stating that you are an
     authorized representative of App Subscriber, you have read and understand
     the terms and conditions of the App License Terms  available at
     <a
      class="link color-light-blue"
      href="https://www.domo.com/company/app-eula">
       https://www.domo.com/company/app-eula
     </a>,
     and that on behalf of Subscriber you agree to all provisions of the App License Terms.
   </p>
 </section>
</template>

<script>
export default {
  name: 'DetailEula',
};
</script>
